<template>
  <div class='leftside-menu' v-bind:class='{ close: !visible }'>
    <div class=''>
      <ul>

        <li>
          <a @click.prevent.stop='$emit("showtemplate")'
            :class='{ disabled: !(mode === Modes.NONE || mode === Modes.TEMPLATE) }'
          >
            <img style='margin-left:22px;' src='@/assets/images/ui/template-icon.png' />
            <span>{{ $t('テンプレート') }}</span>
          </a>
        </li>

        <li v-if="isViewer">
          <a @click.prevent.stop='$emit("uploaddesign")'
            :class='{ disabled: !(mode === Modes.NONE || mode === Modes.UPLOAD) }'
          >
            <img style='margin-left:18px;' src='@/assets/images/ui/upload-icon.png' />
            <span>{{ $t('アップロード') }}</span>
          </a>
        </li>

        <li v-if="isViewer">
          <template v-if='mode !== Modes.TOOLPATH'>
            <a @click.prevent.stop='$emit("togglesbp")'
              :class='{ disabled: !generatable || !(mode === Modes.NONE || mode === Modes.TOOLPATH) }'
            >
              <img style='margin-left:16px;' src='@/assets/images/ui/simulate-icon.png' />
              <span>{{ $t('ツールパス生成') }}</span>
            </a>
          </template>
          <template v-else>
            <a @click.prevent.stop='$emit("togglesbp")'>
              <img style='margin-left:16px;' src='@/assets/images/ui/editing-icon.png' />
              <span>{{ $t('編集に戻る') }}</span>
            </a>
          </template>
        </li>

        <li v-if="isAREnabled">
          <a @click.prevent.stop="viewInAR()"
            :class="{ disabled: !generatable || !(mode === Modes.NONE || mode === Modes.TOOLPATH) }"
          >
            <img style='margin-left:16px;' src='@/assets/images/ui/simulate-icon.png' />
            <span>{{ $t('ARで見る') }}</span>
          </a>
        </li>

        <li>
          <a @click.prevent.stop="$emit('downloadDXF')"
            :class="{ disabled: !generatable || !(mode === Modes.NONE || mode === Modes.TOOLPATH) }"
          >
            <img style='margin-left:16px;' src='@/assets/images/ui/simulate-icon.png' />
            <span>{{ $t('DXFダウンロード') }}</span>
          </a>
        </li>

        <li class="manufacture-btn">
          <a @click.prevent.stop="$emit('cutOrder')"
            :class="{ disabled: !generatable || !(mode === Modes.NONE || mode === Modes.TOOLPATH) }"
          >
            <img style='margin-left:16px;' :src="(!generatable || !(mode === Modes.NONE || mode === Modes.TOOLPATH)) ? whiteIcon : blackIcon" />
            <span>{{ $t('加工へ進む') }}</span>
          </a>
        </li>

      </ul>
    </div>
    <div class='open-close'>
      <a @click.prevent='visible = !visible'>
        <img v-if='visible' src='@/assets/images/ui/left-arrow.png' />
        <img v-else src='@/assets/images/ui/right-arrow.png' />
      </a>
    </div>
  </div>
</template>

<script>

import Modes from '../../assets/javascripts/misc/Modes';

export default {
  props: {
    userAgent: {
      type: String,
      default: ''
    },
    isAREnabled: {
      type: Boolean,
      default: false
    },
    generatable: {
      type: Boolean,
      default: true
    },
    mode: {
      default: Modes.NONE
    }
  },

  data () {
    return {
      Modes: Modes,
      visible: true,

      whiteIcon: require('@/assets/images/ui/simulate-icon.png'),
      blackIcon: require('@/assets/images/ui/simulate-icon-black.png')
    };
  },

  computed: {
    isViewer() {
      return this.$emarf.isViewer;
    }
  },

  methods: {
    viewInAR() {
      if (this.userAgent === "iOS") {
        this.$emit("iosAR");
      }
      else if (this.userAgent === "Android") {
        this.$emit("androidAR");
      }
      else {
        this.$emit("qrcode");
      }
    }
  }
};

</script>

<style lang="scss" scoped>
  .manufacture-btn{
    a{
      background: #1BFFC6 !important;
      color: #000;

      &:hover{
        background: #1be0a8 !important;
      }
    }
  }
  .open-close{
    a{
      border-radius: 0 5px 5px 0;
      // height: 367.8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/viewer/LeftsideMenu.vue